import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Legacy /team route — every existing in-app caller sets `otherTeamId` in
 * sessionStorage and navigates here. The canonical team page is now
 * /public-team/:teamId, so we just forward on mount.
 *
 * Kept as a route component so all the old `to="/team"` + sessionStorage
 * callers across the app keep working without per-file edits.
 */
const Team = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const id = sessionStorage.getItem('otherTeamId');
    if (id) {
      navigate(`/public-team/${id}`, { replace: true });
    } else {
      navigate('/home', { replace: true });
    }
  }, [navigate]);

  return null;
};

export default Team;
